export const DefaultTransitionFunctionConst = 'cubic-bezier(0.15, 0.65, 0.18, 1.09)';
